import styled from "styled-components";
import { Button } from "react-bootstrap";
import { Calendar } from "primereact/calendar";

const StyledModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 16px;
    height: 48px;
    background: #f0f2f2;
    border: 1px solid #f0f2f2;
`;

const StyledCalendar = styled(Calendar)`
    &.p-calendar .p-inputtext {
        border: transparent !important;
        background: #f0f2f2;
        cursor: pointer;
        font-size: 17px;
        line-height: 150%;
        text-align: center;
    }
`;

const BtnOk = styled(Button)`
    width: 84px;
    height: 48px;
    color: #fff;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
`;
export default { StyledCalendar, StyledModalHeader, BtnOk };
